import { render, staticRenderFns } from "./UiAgentInvoiceChoice.vue?vue&type=template&id=ecd84b6a&lang=pug&"
import script from "./UiAgentInvoiceChoice.vue?vue&type=script&lang=js&"
export * from "./UiAgentInvoiceChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports